// data/languages/yoruba/categories/nourritures.ts

import { CategoryData } from '../../../../types/types';

export const nourriture: CategoryData = {
  'Oúnjẹ': { translation: 'Nourriture / Repas', translationEn: 'Food / Meal', illustration: '🍽️' },
  'Omi': { translation: 'Eau', translationEn: 'Water', illustration: '💧' },
  'Búrẹ́dì': { translation: 'Pain', translationEn: 'Bread', illustration: '🍞' },
  'Ìrẹsì': { translation: 'Riz', translationEn: 'Rice', illustration: '🍚' },
  'Ẹran': { translation: 'Viande', translationEn: 'Meat', illustration: '🥩' },
  'Ẹja': { translation: 'Poisson', translationEn: 'Fish', illustration: '🐟' },
  'Ẹyin': { translation: 'Œuf', translationEn: 'Egg', illustration: '🥚' },
  'Wàrà': { translation: 'Lait', translationEn: 'Milk', illustration: '🥛' },
  'Ẹ̀fọ́': { translation: 'Légumes-feuilles / Sauce aux feuilles', translationEn: 'Leafy vegetables / Vegetable stew', illustration: '🥬' },
  'Èso': { translation: 'Fruit', translationEn: 'Fruit', illustration: '🍎' },
  'Ọ̀gẹ̀dẹ̀': { translation: 'Banane / Plantain', translationEn: 'Banana / Plantain', illustration: '🍌' },
  'Ọsàn': { translation: 'Orange', translationEn: 'Orange', illustration: '🍊' },
  'Àgbàdo': { translation: 'Maïs', translationEn: 'Maize / Corn', illustration: '🌽' },
  'Ẹ̀pà': { translation: 'Arachide', translationEn: 'Groundnut / Peanut', illustration: '🥜' },
  'Ẹ̀wà': { translation: 'Haricots', translationEn: 'Beans', illustration: '🫘' },
  'Iṣu': { translation: 'Igname', translationEn: 'Yam', illustration: '🍠' },
  'Iyán': { translation: 'Igname pilée', translationEn: 'Pounded yam', illustration: '🍚' },
  'Àmàlà': { translation: 'Pâte de farine d\'igname (plat d\'Ibadan)', translationEn: 'Yam flour swallow (Ibadan speciality)', illustration: '🟤' },
  'Gààrí': { translation: 'Gari (semoule de manioc)', translationEn: 'Gari (cassava granules)', illustration: '🌾' },
  'Ẹ̀bà': { translation: 'Pâte de gari', translationEn: 'Eba (gari swallow)', illustration: '🟡' },
  'Ọbẹ̀': { translation: 'Sauce / Ragoût', translationEn: 'Soup / Stew', illustration: '🍲' },
  'Ẹ̀gúsí': { translation: 'Sauce aux graines de melon', translationEn: 'Melon seed soup', illustration: '🍲' },
  'Ewédú': { translation: 'Sauce gluante aux feuilles de corète', translationEn: 'Jute leaf soup', illustration: '🥣' },
  'Gbẹ̀gìrì': { translation: 'Soupe de haricots (servie avec l\'àmàlà)', translationEn: 'Bean soup (served with amala)', illustration: '🥣' },
  'Àkàrà': { translation: 'Beignets de haricots', translationEn: 'Bean fritters', illustration: '🧆' },
  'Mọ́ínmọ́ín': { translation: 'Gâteau de haricots cuit à la vapeur', translationEn: 'Steamed bean pudding', illustration: '🫘' },
  'Dòdò': { translation: 'Banane plantain frite', translationEn: 'Fried plantain', illustration: '🍌' },
  'Ata': { translation: 'Piment', translationEn: 'Pepper / Chilli', illustration: '🌶️' },
  'Iyọ̀': { translation: 'Sel', translationEn: 'Salt', illustration: '🧂' },
  'Ṣúgà': { translation: 'Sucre', translationEn: 'Sugar', illustration: '🍬' },
  'Epo pupa': { translation: 'Huile de palme (litt. « huile rouge »)', translationEn: 'Palm oil (lit. "red oil")', illustration: '🫗' },
  'Tíì': { translation: 'Thé', translationEn: 'Tea', illustration: '🍵' },
  'Kọfí': { translation: 'Café', translationEn: 'Coffee', illustration: '☕' },
  'Ẹmu': { translation: 'Vin de palme', translationEn: 'Palm wine', illustration: '🥥' },
};

export default nourriture;
